import {getCategories, getDocuments} from '../api/download';
import {getCadCategories, getConstructions, searchCad} from '../api/cad';
import filter from 'lodash/filter';

export const downloadModule = {
    namespaced: true,
    state: {
        type: 'documents',
        categrories: {
            list: [],
            processing: false,
        },
        documents: {
            list: [],
            processing: false,
        }
    },
  getters: {
    processing(state) {
      return state.documents.processing;
    },
    categories(state) {
      return state.categrories.list;
    },
    documents(state) {
      return state.documents.list;
    },
    rootCategories(state, getters) {
      return filter(getters.categories, category => category.parent_id === null);
    },
    type(state) {
      return state.type;
    }
  },

  actions: {
    setType({ commit }, type) {
      commit('setType', type);
    },
    fetchCategories({ commit, getters }) {
      let clbFunction = {
        cad: () => getCadCategories(),
        documents: () => getCategories(),
      };
      commit('fetchCategoriesProcess', true);
      return clbFunction[getters.type]()
        .then((data) => {
          commit('setCategories', data);
          commit('fetchCategoriesProcess', false);
        }).catch(() => {
          commit('setCategories', []);
          commit('fetchCategoriesProcess', false);
        });
    },
    fetchDocuments({ commit, getters }, categoryId) {
      commit('fetchDocumentsProcess', true);
      commit('setDocuments', []);

      if (!categoryId) {
        commit('fetchDocumentsProcess', false);
        return null;
      }

      // Recursive function to find the documents by categoryId
      const findDocumentsByCategoryId = (categories, categoryId) => {
        for (const category of categories) {
          if (category.id === categoryId) {
            return category.documents || [];
          }
          if (category.children && category.children.length > 0) {
            const result = findDocumentsByCategoryId(category.children, categoryId);
            if (result.length > 0) {
              return result;
            }
          }
        }
        return [];
      };

      // Get the documents from the categories
      const documents = findDocumentsByCategoryId(getters.categories, categoryId);

      // Commit the found documents or an empty array if none found
      commit('setDocuments', documents);
      commit('fetchDocumentsProcess', false);
    },
    searchDocuments({ commit, getters }, s) {
      commit('fetchDocumentsProcess', true);
      commit('setDocuments', []);
      return searchCad(s)
        .then((data) => commit('setDocuments', data))
        .catch(() => commit('setDocuments', []))
        .finally(() => commit('fetchDocumentsProcess', false));
    },
    setDocuments({ commit }, documents) {
      commit('setDocuments', documents);
    }
  },
  mutations: {
    setCategories(state, categories = []) {
      state.categrories.list = categories;
    },
    setDocuments(state, documents = []) {
      state.documents.list = documents;
    },
    fetchCategoriesProcess(state, status) {
      state.categrories.processing = status;
    },
    fetchDocumentsProcess(state, status) {
      state.documents.processing = status;
    },
    setType(state, type) {
      state.type = type;
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/download/store/index.js